import type {
  ClickableLabeledImageItem,
  SuggestionButtonPopover,
} from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'

type ProductGridPopoverParams = {
  title: string
  items: ClickableLabeledImageItem[]
  onLoadMore: (onComplete?: () => void) => void
}

export function createProductGridPopover({
  title,
  items,
  onLoadMore,
}: ProductGridPopoverParams): SuggestionButtonPopover {
  return {
    designType: 'grid',
    title,
    width: 320,
    height: 400,
    columns: 3,
    aspectRatio: '1',
    items,
    onLoadMore,
    scrollToBottom: true,
  }
}
